import { PublicationCardItem } from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { FC } from 'react'
import { ThemedRender } from '../../../__styling/themed-render'
import CommentsCount from '../../TheNightly/components/card-body/byline/CommentsCount'
import {
    StyledListCardKicker,
    StyledNightlyTopicLabel,
    StyledTopicLabel,
} from '../ListCard.styled'

interface ListCardTopicTagProps {
    item: MaybeLoaded<PublicationCardItem>
    level?: 'parent'
}

export const ListCardTopicTag: FC<ListCardTopicTagProps> = (props) => {
    const { item, level } = props

    if (!item || !item.loaded) {
        return null
    }

    const result = item.result
    const topic = result.primaryTopic
    const text = result.primaryTopic.title

    return (
        <ThemedRender
            perthnow={() => <StyledTopicLabel topic={topic} text={text} />}
            sevennews={() => (
                <StyledListCardKicker>{result.kicker}</StyledListCardKicker>
            )}
            thenightly={() => (
                <StyledNightlyTopicLabel>
                    {level === 'parent' ? topic.parent?.title ?? text : text}
                    {result.allowCommenting && (
                        <CommentsCount articleUrl={result._self} />
                    )}
                </StyledNightlyTopicLabel>
            )}
        />
    )
}
ListCardTopicTag.displayName = 'ListCardTopicTag'
